import type { EventInfo } from '@/types/event';
import type { SearchedEventDetail } from '@/types/search';

export const transformEventSearchResponse = (events: SearchedEventDetail[]): EventInfo[] => {
	return events.map((event: SearchedEventDetail): EventInfo => {
		const timezone = event.start.timezone;
		const displayDate = formatEventDisplayDate(event.start.utc, timezone);
		const displayTime = formatEventDisplayTime(event.start.utc, timezone);
		const status = derivedEventSoldoutStatus(event.status, event.end);
		const isSoldout = event.status === EVENT_STATUS.SOLD_OUT;

		return {
			locationType: event.locationType,
			id: event.id,
			groupId: event.group.id,
			groupName: event.group.name,
			groupLogo: event.group.logo,
			status,
			coverImageUrl: event.coverImage,
			name: event.name,
			address: event.address,
			displayDate,
			displayTime,
			displayTimezone: getTimezoneAbbreviation(timezone),
			isHappeningNow: calculateHappeningNow(event.start, event.end),
			isEventSeries: event.badges.isSeries,
			isEventFree: event.badges.isFree,
			isSoldout,
			avatarUrl: event.organizer.avatar,
			organizer: event.organizer.nickname,
			organizerId: event.organizer.id,
		};
	});
};